import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import { type RegionsState } from "./useTaskCreation";
import type { JSX } from "react";

interface RegionSelectProps {
  regionsState: RegionsState;
  value: string;
  // undefined — к выбранному региону претензий нет: поле рисуется без подписи
  // об ошибке.
  error: string | undefined;
  disabled: boolean;
  onChange: (value: string) => void;
  onRetry: () => void;
}

export function RegionSelect(props: RegionSelectProps) {
  let regionSelect: JSX.Element;
  if (props.regionsState.kind === "loading") {
    regionSelect = (
      <Box display="flex" alignItems="center" gap={1} mb={2}>
        <CircularProgress size={20} />
        <Typography variant="body2" color="text.secondary">Загрузка регионов…</Typography>
      </Box>
    );
  } else {
    if (props.regionsState.kind === "error") {
      regionSelect = (
      <Alert
        severity="error"
        sx={{ mb: 2 }}
        action={
          <Button color="inherit" size="small" onClick={props.onRetry}>
            Повторить
          </Button>
        }
      >
        {props.regionsState.message}
      </Alert>
    );
    } else {
      regionSelect = (
    <TextField
      select
      label="Регион"
      value={props.value}
      error={!!props.error}
      helperText={props.error}
      disabled={props.disabled}
      onChange={(event) => props.onChange(event.target.value)}
      fullWidth
      size="small"
      sx={{ mb: 2 }}
    >
      {props.regionsState.regions.map(({ region, siteCount }) => (
        <MenuItem key={region} value={region}>{region} ({siteCount} сайтов)</MenuItem>
      ))}
    </TextField>
  );
    }
  }
  return regionSelect;
}
